import { Component, inject, Input } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MasterDataDTO } from 'src/app/models/MasterDataDTO.model';
import { MasterdataRequestDTO } from 'src/app/models/MasterdataRequestDTO.model';
import { UserDTO } from 'src/app/models/UserDTO.model';
import { CustomerService } from 'src/app/services/customer.service';
import { Alert } from 'src/app/shared/models/Alert';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';
import { emailValidator } from 'src/app/validators/email.validator';
import { CommonModule, Location } from '@angular/common';
import { FormatEmailDirective } from '../../../../directives/format-email.directive';
import { FormatPhoneUsDirective } from '../../../../directives/format-phone-us.directive';

@Component({
    selector: 'app-assign-distributor-staff',
    templateUrl: './assign-distributor-staff.component.html',
    styleUrls: ['./assign-distributor-staff.component.css'],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, FormatPhoneUsDirective, FormatEmailDirective]
})
export class AssignDistributorStaffComponent {
  @Input() distributorDataInput: any;

  form = new FormGroup({ email: new FormControl('', [Validators.required, emailValidator()]) });
  get emailModel() { return this.form.get('email'); }

  information: string = 'Assign Distributor Staff';
  customerName: string = '';
  address: string = '';
  city: string = '';
  zipCode?: number = undefined;
  stateSelected: string = '';
  states: MasterDataDTO[] = [];
  contactNumber?: string = undefined;
  email: string = '';
  fieldsCompleted: boolean = false;
  validMail: boolean = false;
  masterdataRequestDTO: MasterdataRequestDTO = { idMaster: 1 };
  alert: Alert = {} as Alert;

  staff: UserDTO = {
    userAddressLine1: '', userAddressLine2: '', userCity: '', userMail: '',
    userExpirationPass: new Date('2020-05-05'), userNames: '', userPassword: '',
    userPhone: undefined, userPostalCode: undefined, userRegister: new Date('2020-05-05'),
    userState: '', userId: undefined, userStatus: undefined, numberPlans: undefined,
    numberDevices: undefined, listUserRole: [], listUserPlanDev: []
  };

  public location = inject(Location);
  private customerService = inject(CustomerService);
  private alertService = inject(AlertService);
  public permissionsService = inject(ValidatePermissionsService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  ngOnInit() {
    this.permissionsService.validateAccessLevels(MODULE_ID.Distributors);
    this.customerService.getMastersById(this.masterdataRequestDTO).subscribe(
      ({ Data, StatusCode }) => Data != null ? this.states = Data : this.showError(),
      () => { this.showError(); this.clearFields(); }
    );
  }

  goBack() {
    this.location.back();
  }

  createDistributorCustomer() {
    this.staff.userId = this.distributorDataInput?.userId ?? this.distributorDataInput;
    this.staff.userAddressLine1 = this.address;
    this.staff.userPhone = this.contactNumber;
    this.staff.userNames = this.customerName;
    this.staff.userMail = this.email;
    this.staff.userState = this.stateSelected;
    this.staff.userPostalCode = this.zipCode;
    this.staff.userCity = this.city;

    /*
    this.customerService.createUserStaff(this.customer).subscribe(
      ({ StatusCode, Message, Data }) =>
      Data != null
      ? this.handleSaveSuccess(Data)
      : this.handleSaveError(StatusCode),
      (error) => {
        this.CustomerMessageError = 'Unexpected error. Please try again later.';
        this.clearFields();
      }
    );
    */

    //this.customerService.createDistributorCustomer(this.staff).subscribe(
    this.customerService.createUserStaff(this.staff).subscribe(
      ({ Data, StatusCode }) => {
        if (Data != null) {
          if ((Data as any).userId === 0) {
            this.alert = { alertMessage: 'This user already exists', alertType: 'alert alert-warning', alertCenter: false, alerTitle: '', duration: 3000 };
            this.alertService.updateAlertState(this.alert);
          } else {
            this.alert = { alertMessage: 'Distributor Staff User saved successfully', alertType: 'alert alert-success', alertCenter: false, alerTitle: '', duration: 3000 };
            localStorage.setItem('AlertObject', JSON.stringify(this.alert));
            this.alertService.updateAlertState(this.alert);
            this.clearFields();
            location.reload();
          }
        } else {
          this.showError();
        }
      },
      () => { this.showError(); this.clearFields(); }
    );
  }

  checkFields() {
    this.checkEmailValidity();
    this.fieldsCompleted = !!(this.customerName && this.contactNumber && this.email && this.validMail);
  }

  checkEmailValidity() { this.validMail = !!this.emailModel?.valid; }

  clearFields() {
    this.address = ''; this.contactNumber = undefined; this.customerName = '';
    this.email = ''; this.stateSelected = ''; this.zipCode = undefined; this.city = '';
  }

  showError() {
    this.alert = { alertMessage: 'Unexpected error. Please try again later.', alertType: 'alert alert-danger', alertCenter: false, alerTitle: '', duration: 3000 };
    this.alertService.updateAlertState(this.alert);
  }
}
